import script from "./MainAutoMessageCf.vue?vue&type=script&setup=true&lang=js"
export * from "./MainAutoMessageCf.vue?vue&type=script&setup=true&lang=js"

import "./MainAutoMessageCf.vue?vue&type=style&index=0&id=275c8b36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-275c8b36"]])

export default __exports__